var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.03897 38.1225L7.03897 38.1226L16.2644 35.626L16.3399 35.7014L16.34 35.7013C16.3401 35.7012 16.3401 35.7011 16.3402 35.701L37.679 14.3638C37.9364 14.1594 38.0923 13.8531 38.1057 13.5242C38.1192 13.1939 37.9879 12.8741 37.7461 12.6491L31.3456 6.24909C31.1318 6.02186 30.8336 5.89333 30.5219 5.89333C30.2103 5.89333 29.9121 6.02186 29.6983 6.24911L8.35641 27.5894C8.35633 27.5895 8.35625 27.5896 8.35618 27.5896C8.21759 27.7265 8.11919 27.8985 8.07176 28.0876L8.07174 28.0877L5.93795 36.6223C5.82087 37.0181 5.93843 37.4462 6.24089 37.7268C6.44017 37.9641 6.72906 38.1078 7.03897 38.1225ZM27.9195 11.3391L30.522 8.73662L35.2588 13.4729L32.6563 16.0754L27.9195 11.3391ZM10.8446 28.4118L26.2532 13.0048L30.9901 17.7411L15.5814 33.1487L10.8446 28.4118ZM8.66307 35.3297L9.81259 30.7123L13.281 34.1807L8.66307 35.3297Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.213333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencil-icon.9ba3c75a0c601053b50b5128acad910a.svg";
export { ForwardRef as ReactComponent };